import { PRODUCT_SEARCH_FILTERS } from '@/utils/productSearchFilters';
import spannrahmen from './multiPositionExtensions/spannrahmen';
import { fittingCode } from './FittingDimensions';

// Hinged frame fittings in 03_BeschlagDetails.sql (article 1), corroborated by
// their DIN/hinge-specific catalog steps. Rotating Universa clips are not hinges.
export const EXCLUDED_HINGED_FRAME_CODES = Object.freeze([
  '251', '261', '261-M', '261-MC', '261-SD', '263', '265', '281', '286',
]);

// Enable an area only after its catalog and special rules have been validated.
// Article IDs remain defined by the existing product-area mapping.
const enabledAreas = {
  rahmen: {
    enabled: true, extension: spannrahmen,
    isVariantAllowed: ({ code }) => !!code && !EXCLUDED_HINGED_FRAME_CODES.includes(code.replace(/-XL$/, '')),
  },
};

export const MULTI_POSITION_PRODUCT_AREAS = Object.freeze(Object.fromEntries(
  PRODUCT_SEARCH_FILTERS.map(area => [area.key, Object.freeze({
    enabled: false, extension: null, ...enabledAreas[area.key],
  })])
));

export function resolveMultiPositionProduct(articleId, variant = '', settings = MULTI_POSITION_PRODUCT_AREAS) {
  const area = PRODUCT_SEARCH_FILTERS.find(candidate => candidate.articleIds.includes(Number(articleId)));
  const configuration = area && settings[area.key];
  const selection = { articleId: Number(articleId), variant, code: fittingCode(variant) };
  return configuration?.enabled && (!configuration.isVariantAllowed || configuration.isVariantAllowed(selection)) ? {
    key: area.key, label: area.label, extension: configuration.extension || {},
  } : null;
}
